// extracted by mini-css-extract-plugin
export default {"row":"Severity_row__JGLmS","col1":"Severity_col1__hGAx7","col2":"Severity_col2__tKKkq","required":"Severity_required__7URca"};